import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import AppModalContent from "../../Modals/AppModalContent";
import {
  OneflowContractRefDisplay,
  OneflowContractRefDisplayProps,
} from "./OneflowContractRefDisplay";

type Props = Omit<AppModalProps, "children"> & {
  subProps: OneflowContractRefDisplayProps;
};

export function OneflowContractRefDisplayModal({ subProps, ...dialogProps }: Props) {
  return (
    <AppModal fullWidth maxWidth='md' {...dialogProps}>
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>Oneflow contract info</AppModalTitle>
          <AppModalContent>
            <OneflowContractRefDisplay {...subProps} />
          </AppModalContent>
        </>
      )}
    </AppModal>
  );
}
